module.exports = "/_next/static/images/4634e8f4d8855bc31ad9a76a051549b3-woman-with-sandwich@0.5x.jpg.webp";